import { defaultCarbonOffsetFee } from './constants'

export const getCarbonOffsetFeeAmount = ({ config, defaultStoreCurrency, language }) => {
  const currency = config?.currency || defaultStoreCurrency
  const fee = config?.carbon_offset_fee || defaultCarbonOffsetFee

  return new Intl.NumberFormat(language, { style: 'currency', currency }).format(fee)
}
